import {
    Component, Input, OnInit
} from '@angular/core';

@Component({
    selector: 'tk-time',
    styleUrls: ['./time.component.less'],
    templateUrl: './time.component.html'
})
export class TimeComponent implements OnInit {
    @Input()
    public minutes?: number;

    public d?: string;
    public h?: string;
    public m?: string;

    ngOnInit() {

        let minutes = Math.ceil(this.minutes!);
        const h = Math.floor(minutes / 60);
        minutes = minutes - h * 60;
        const m = minutes;


        this.h = (h >= 10 ? '' : '0') + h.toString();
        this.m = (m >= 10 ? '' : '0') + m.toString();
    }
}
